module.exports = __webpack_public_path__ + "media/src/application/media/favicon-600c61bbc92c3cdbbfec9d15d7886074.svg";